import { mergeMap, map } from 'rxjs/operators';
import { OrgModel } from './../../store/storeModels/user.model';
import { Injectable } from '@angular/core';
import { Endpoints } from 'src/app/shared/config/endpoints';
import { HttpClient } from '@angular/common/http';
import { AppState } from 'src/app/store/app.state';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TicketSettingsService {
  readonly api = this.endpoint.settingsApi;
  readonly signUpApi = this.endpoint.signupUrl;
  readonly ticketApi = this.endpoint.ticketUrl;
  readonly chatApi = this.endpoint.chatServiceUrl;
  private org: OrgModel;
  department: any; 
  constructor(
    private endpoint: Endpoints,
    private http: HttpClient,
    store: Store<AppState>) {
      store.select('userInfo').subscribe(info => {
        this.org = info.organization;
      })
      this.department = JSON.parse(localStorage.getItem("departmentInfo"));
    }
  
  newTicketResTime(payload) { 
    const body = {
      ...payload,
      orgID: this.org.id
    }
    return this.http.post(this.api + '/newTicketResponseTime', body)
  }
  editTicketResTime(payload) { 
    const body = {
      ...payload,
      orgID: this.org.id
    }
    return this.http.post(this.api + '/editTicketResponseTime', body)
  }
  fetchAutomaticTime() {
    return this.http.get(this.api + `/${this.org.id}/getAutomaticTime`)
  }
  newResSla(payload) {
    const body = {
      ...payload,
      orgID: this.org.id,
      clientName: payload.clientName.name,
      clientID: payload.clientName.id,
      departmentID: this.department? this.department.id: ''
    }
    return this.http.post(this.api + '/newResolutionSLA', body)
  }
  fetchSLAs() {
    return this.http.get(this.api + `/${this.org.id}/getSLAs`);
  }
  fetchSLAsByDepartment(departmentID) {
    return this.http.get(this.api + `/resolution-sla/${this.org.id}/${departmentID}`);
  }
  deleteSLA(id) {
    return this.http.delete(this.api + `/${id}/deleteResolutionSLA` )
  }
  fetchWorkingDays() {
    return this.http.get(this.api + `/${this.org.id}/getWorkingDays`)
  }
  saveWorkingDays(paylooad) {
    const body = {...paylooad, orgID: this.org.id}
    return this.http.post(this.api+ '/saveWorkingDays', body)
  }
  saveAgentsOnCall(payload: any[]) {
    const body = payload.map(agent => ({agentID: agent.id, orgID: this.org.id}))
    return this.http.post(this.api+ '/agentsOnCall', body)
  }
  fetchAgentsOnCall() { 
    return this.http.get(this.api+ `/agentsOnCall/${this.org.id}`)
    .pipe(mergeMap((agents: any[]) => {
        let result
        if(agents.length) {
          const ids = agents.map(agent => agent.agentID)
          result = this.http.get(`${this.signUpApi}/getAllUserDetails/${ids}`)
          .pipe(map((users: any[]) => {
            const userdWithId = users.map((user, index) => {
              return ({name: `${user.firstName} ${user.lastName}`, tableId: agents[index].id, agentID: agents[index].agentID})
            })
            return userdWithId
          }));
        } else {          
          result = of(agents);
        }
      return result;
    }));
  }
  deleteAgentOnCall(ids) {
    return this.http.delete(this.api + `/agentsOnCall/${ids}`);
  }
  saveAutoResponse(payload) {
    const body = {...payload, orgID: this.org.id, departmentID: this.department? this.department.id: ''};
    let endpoint = payload.id ? '/autoReply/update' : '/autoReply';
    return this.http.post(this.ticketApi + endpoint, body);
  }
  fetchAutoResponse() {
    return this.http.get(this.ticketApi +`/autoReply/${this.org.id}`).pipe(
      mergeMap((data: any[]) =>  {
        const result =  data.filter(dat => !dat.departmentID).map(dat => ({id: dat.id, channel: dat.channel, message: dat.message, subject: dat.subject, offlineMessage: dat.offlineMessage}))
        return of(result)
      })
    )
  };

  fetchDepartmentAutoResponse(departmentID) {
    return this.http.get(this.ticketApi +`/autoReply/department/${this.org.id}/${departmentID}`).pipe(
      mergeMap((data: any[]) =>  {
        const result =  data.map(dat => ({id: dat.id, channel: dat.channel, message: dat.message, subject: dat.subject, offlineMessage: dat.offlineMessage}))
        return of(result)
      })
    )
  };

  fetchAgentAvailability(){
    return this.http.get(`${this.chatApi}/availability/${this.org.id}`)
  }

  fetchAgentAvailabilityByDepartment(departmentID){
    return this.http.get(`${this.chatApi}/availability/${this.org.id}/${departmentID}`)
  }

  addAgentAvailability(payload){
    const body = {...payload, orgID: this.org.id, departmentID: this.department? this.department.id: ''};
    return this.http.post(`${this.chatApi}/availability/create`, body);
  }

  assignKeywords(body){
    const payload = { ...body, departmentID: this.department? this.department.id: ''}
    return this.http.post(`${this.ticketApi}/assignKeywords`, payload)
  }

  getAssignKeywords(){
    return this.http.get(`${this.ticketApi}/getAssignKeywords/${this.org.id}`)
  }

  getAssignKeywordsByDepartment(departmentID){
    return this.http.get(`${this.ticketApi}/getAssignKeywords/${this.org.id}/${departmentID}`)
  }

  getTicketPriorityist(){
    return this.http.get(`${this.ticketApi}/getTicketTypePriorities`)
  }

  editAssignKeywords(body){
    return this.http.put(`${this.ticketApi}/editAssignKeywords`,body)
  }

  deleteAssignKeywords(id){
    return this.http.delete(`${this.ticketApi}/deleteAssignKeywords/${id}`)
  }

  createSupervisors(body){
    return this.http.post(`${this.ticketApi}/createSupervisors`,body)
  }

  getTicketSupervisors(){
    return this.http.get(`${this.ticketApi}/getTicketSupervisors/${this.org.id}`)
  }

  getTicketSupervisorDetails(supervisorID){
    return this.http.get(`${this.ticketApi}/getSupervisors/${this.org.id}/${supervisorID}`)
  }
  getSupervisorsSubordinates(supervisorID){
    return this.http.get(`${this.ticketApi}/getSupervisorsSubordinates/${this.org.id}/${supervisorID}`)
  }   

  editSupervisors(body){
    const payload = {...body,orgID:this.org.id}
    return this.http.put(`${this.ticketApi}/editSupervisors`,payload)
  }
  addTicketSLA(body){
    const payload = {...body,orgID:this.org.id}
    return this.http.post(this.ticketApi + '/addTicketSLA',payload)
  }

  editTicketSLA(body){
    const payload = {...body,orgID:this.org.id}
    return this.http.put(this.ticketApi + '/editTicketSLA',payload)
  }

  getEscalations(){
    return this.http.get(this.ticketApi + '/escalations')
  }

  fetchTicketSla(){
    return this.http.get(this.ticketApi +`/getByOrgID/${this.org.id}`)
  }

  setSLA(isOn){
    return this.http.get(`${this.ticketApi}/toggleSLASettings/${this.org.id}/${isOn}`)
  }

  deleteTicketSupervisor(id){
    return this.http.delete(`${this.ticketApi}/deleteSupervisors/${id}`)

}

setCustomStatus(id, customState){
  return this.http.get(`${this.ticketApi}/sla-setting/${id}/custom?customState=${customState}`)
}

createSlaCustomSetup(body) {
  return this.http.post(`${this.ticketApi}/sla-custom-setups`, body);
}

getSlaCustomSetups(page, size) {
  return this.http.get<any>(this.ticketApi + `/sla-custom-setups/${this.org.id}/all?pageNo=${page}&pageSize=${size}`);
}

getSlaCustomSetup(id) {
  return this.http.get<any>(this.ticketApi + `/sla-custom-setups/${id}`);
}

deleteSlaCustomSetup(id) {
  return this.http.delete<any>(this.ticketApi + `/sla-custom-setups/${id}`);
}

editSlaCustomSetup(body, id) {
  return this.http.patch(`${this.ticketApi}/sla-custom-setups/${id}`, body);
}

addSubordinate(body){
  const payload = {...body,orgID:this.org.id}
  return this.http.put(`${this.ticketApi}/addSubordinates`,payload)
}

createSuperior(body){
  const payload = {...body,orgID:this.org.id}
  return this.http.post(`${this.ticketApi}/createSuperior`,payload)
}

getAllSuperiors(){
 
  return this.http.get(`${this.ticketApi}/getAllSuperiors/${this.org.id}`)
}

deleteSuperior(id){
  return this.http.delete(`${this.ticketApi}/deleteSuperior/${id}`)
}

getGroups(){
  return this.http.get(`${this.ticketApi}/groups/organization/${this.org.id}`)
}

createGroupSupervisor(payload){
  const body = {...payload,orgID:this.org.id}
  return this.http.post(`${this.ticketApi}/createGroupSupervisor`,body)
}

getGroupBySupervisorID(supervisorID){
  return this.http.get(`${this.ticketApi}/getBySupervisorID/${this.org.id}/${supervisorID}`)
}

getGroupByGroupID(groupID){
  return this.http.get(`${this.ticketApi}/getByGroupID/${this.org.id}/${groupID}`)
}


getAllGroupSupervisors(){
  return this.http.get(`${this.ticketApi}/getAllGroupSupervisors/${this.org.id}`)
}

deleteGroupSupervisor(id){
  return this.http.delete(`${this.ticketApi}/deleteGroupSupervisor/${id}`)
}


getSuperiorsSubordinates(superiorUserID){
  return this.http.get(`${this.ticketApi}/getSuperiorsSubordinates/${this.org.id}/${superiorUserID}`)
}
 
updateSuperior(body){
  const payload = {...body,orgID:this.org.id}
  return this.http.put(`${this.ticketApi}/editSuperiors`,payload)
}

deleteSupervisorSubordinate(agentId, orgId, superiorId){
  return this.http.delete(`${this.ticketApi}/delete/subordinate/${agentId}/${orgId}/${superiorId}`)
}
  
}
